import React, { useEffect } from 'react';
import RoundButton from '../../Common/RoundButton';
import BackgroundTheme from '../P2P/Header/BackgroundTheme';
import ErrorMessage from '../ErrorMessage';
import { Divider, Typography } from '@material-ui/core';
import Box from '@mui/material/Box';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { getTransactionConfirmation } from '../../Pages/StashKar/InvestFund/investFundAction';
// import PaymentFailure from "../../Pages/StashKar/Payment/paymentFailure";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { separateCommaNumber } from '../../utils/utils';
import Grid from '@mui/material/Grid';
const InfoFormP2p = (props: any) => {
  const dispatch = useDispatch();
  const { handleSContinue, showBtn, imgShow, imgFail, btnTitle, errorMessage } =
    props;

  const params = new URLSearchParams(window?.location?.search);

  const getParam = (key: string): string | null | number | any => {
    if (params) {
      return params.get(key);
    }
    return '';
  };

  // useEffect(() => {
  //   if(params) dispatch(getTransactionConfirmation());
  // }, [params])
  const getTransactionDate = (): string => {
    const txnTime = getParam('transaction_date');
    if (txnTime) {
      return moment(txnTime).format('DD/MM/YYYY hh:mm a').toUpperCase();
    }
    return '';
  };

  return (
    <>
      <BackgroundTheme>
        <Card className='redBorder'>
          <CardContent>
            <>
              {getParam('transaction_status') === 'success' ? (
                <>
                  <Box className='circleImage'>
                    <img src={imgShow} alt='' />
                  </Box>

                  <Box className='investSuccess'>
                    <Typography variant='h1'>Congratulations!</Typography>
                    <Typography variant='h2'>
                      ₹{' '}
                      {getParam('amount') !== null
                        ? separateCommaNumber(Math.floor(getParam('amount')))
                        : 0}
                    </Typography>
                    <Typography>Investment successful</Typography>
                  </Box>
                </>
              ) : (
                <>
                  <Box className='circleImage'>
                    <img src={imgFail} alt='' />
                    <Box className='investSuccess'>
                      <Typography variant='h1'>
                        Oops there seems <br /> to be a problem
                      </Typography>
                      <Typography>
                        {' '}
                        your transaction has failed <br /> Please try again
                      </Typography>
                    </Box>
                  </Box>
                </>
              )}

              <Box className='idDetails'>
                <Card>
                  <Grid container>
                    <Grid item xs={6}>
                      <Typography>Transaction ID</Typography>
                    </Grid>
                    <Grid item xs={6} textAlign='right'>
                      <span>{getParam('transaction_id') || '-'}</span>
                    </Grid>
                    <hr />
                    <Grid item xs={6}>
                      <Typography>Transaction date </Typography>
                    </Grid>

                    <Grid item xs={6} textAlign='right'>
                      <span>{getTransactionDate() || '-'}</span>
                    </Grid>
                  </Grid>
                </Card>

                {getParam('transaction_status') === 'success' ? (
                  <Card>
                    <Grid container>
                      <Grid item xs={12}>
                        <Typography className='text-center'>
                          Investments may take <br /> up to 48 hours to be
                          allocated <br /> to a borrower.
                        </Typography>
                      </Grid>
                      <hr />

                      <Grid item xs={12}>
                        <Typography className='text-center'>
                          You start earning <br /> interest on your investments
                          once <br /> borrowers are allocated
                        </Typography>
                      </Grid>
                    </Grid>
                  </Card>
                ) : (
                  ''
                )}
              </Box>
            </>
            {errorMessage?.status === false && (
              <ErrorMessage text={errorMessage?.errors} />
            )}
            {showBtn && (
              <div className='cardBottomText'>
                <RoundButton onClick={handleSContinue} title={btnTitle} />
              </div>
            )}
          </CardContent>
        </Card>
      </BackgroundTheme>
    </>
  );
};

export default InfoFormP2p;
